import { createContext, useContext, useEffect, useState } from 'react';
import { deleteSession, getSession, setSession } from '../utils/sessionStore';
import type { LoginResponse } from '@/service/api/auth';

interface AuthContextType {
	userInfo: LoginResponse | null;
	onLogin: (userInfo: LoginResponse) => void;
	onLogout: () => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
	const [userInfo, setUserInfo] = useState<LoginResponse | null>(
		getSession('userInfo')
	);

	const onLogin = (userInfo: LoginResponse) => {
		setSession('userInfo', userInfo, 800);
		setUserInfo(userInfo);
	};

	const onLogout = () => {
		deleteSession('userInfo');
		setUserInfo(null);
	};

	// 세션 만료시 리셋
	useEffect(() => {
		const userInfo = getSession('userInfo');
		if (!userInfo) setUserInfo(null);
	}, []);

	return (
		<AuthContext.Provider value={{ userInfo, onLogin, onLogout }}>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuth = (): AuthContextType => {
	const context = useContext(AuthContext);
	if (!context) {
		throw new Error('useAuth must be used within an AuthProvider');
	}
	return context;
};
